
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { Logger } from "@nolimitcity/slot-launcher/bin/utils/Logger";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { ReelEngineEvent } from "@nolimitcity/slot-game/bin/core/engines/reel/event/ReelEngineEvent";
import { SanEngineController } from "../SanEngineController";
import { SanEngineManager } from "../SanEngineManager";
import { SanSymbolData } from "../Symbol/SanSymbolData";
import { SanSpriteSymbol } from "../Symbol/SanSpriteSymbol";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

export interface IReelItem {
    ReelID:number;
    SymID:number;
}

export interface IItemTransform {
    height:number;
    width:number;
    position:PIXI.Point;
    scale:PIXI.Point;
}

export abstract class ReelItemMap extends BaseView {

    protected _items:IReelItem[] = [];

    protected addEventListeners():void{
        EventHandler.addEventListener(this, ReelEngineEvent.REEL_RESIZED, (event:GameEvent) => this.reelDimUpdated(event.params[0]));
    }

    protected getExistingItem(reelID:number, symID:number):IReelItem | undefined{
        for(let id:number = 0; id < this._items.length; id++){
            if(this._items[id] && this._items[id].ReelID == reelID && this._items[id].SymID == symID) return this._items[id];
        }
        return undefined;
    }

    protected createItem(reelID:number,symID:number, obj:Object):IReelItem{
        return Helper.assignObj({ ReelID:reelID, SymID:symID},obj) as IReelItem;
    }

    public reset():void{
        for(let i = 0; i < this._items.length;i++) if(this._items[i]) delete this._items[i];
        
        this.removeChildren();
        this._items = [];
    }

    protected getSymbolTransformData(item:IReelItem,displayObj?:PIXI.DisplayObject, useMap?:boolean,stateType?:string):IItemTransform | undefined{
        if(item == undefined) return undefined;

        const reelC:SanEngineController = SanEngineManager.getReel(item.ReelID);
        const posId:number = reelC.findHitPosRow(item.SymID)%reelC.windowAmount;
        if(posId == -1 || undefined){
            return {
                position: new PIXI.Point(0,0),
                scale: SanEngineManager.dim.scale,
                width: SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH,
                height: SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT
            }
        }
        let symbol:SanSpriteSymbol = reelC.getSymbol(posId)!;
        let pos:PIXI.Point = new PIXI.Point(0,0);

        if(reelC.getSymbol(posId)){
            if(useMap){
                pos = reelC.getCurrentStatePositionMap(displayObj ? displayObj : this, stateType)[posId + reelC.overflowDirection];
            }else{
                pos = Helper.copyLocalPosition(displayObj ? displayObj : this , symbol);
            }
        }
        const fetchedData:IItemTransform = {
            position: pos,//MathHelper.pointDiv(pos,<PIXI.Point>reelC.scale),
            scale: SanEngineManager.dim.scale,
            width: symbol.symbolWidht,
            height: symbol.symbolHeight

        }
        return fetchedData;
    }

    protected reelDimUpdated(reelID:number):void{
        for(let i = 0; i <  this._items.length;i++) if(this._items[i] && this._items[i].ReelID == reelID) this.updateItemTransform(this._items[i]);
    }

    protected removeItem(reelID:number,symID:number):void{
        this._items = this._items.filter((item) => { return item.ReelID != reelID && item.SymID != symID });
    }

    protected abstract updateItemTransform(item:IReelItem):void;
}